'use client';

import NextLink from 'next/link';
import { center, flex } from '@onbeam/business-styled-system/patterns';
import { BeamLogo } from '@/icons/custom';
import { css } from '@onbeam/business-styled-system/css';
import { DesktopNavItem } from './DesktopNavItem';
import { GetStartedButton } from './GetStartedButton';
import { navItems } from '../Header.utils';

export const DesktopNavigation = () => (
  <>
    <NextLink href="/">
      <BeamLogo />
      <span className={css({ srOnly: true })}>Home</span>
    </NextLink>
    <div
      className={css({
        '@media(max-width: 60rem)': { display: 'none' },
      })}
    >
      <div
        className={center({
          position: 'absolute',
          inset: '0',
          pointerEvents: 'none',
        })}
      >
        <nav
          className={flex({
            textStyle: 'body-sm',
            gap: '[clamp(token(spacing.3), 1.5vw, token(spacing.6))]',
            smDown: {
              display: 'none',
            },
          })}
        >
          {navItems.map((item) => (
            <DesktopNavItem {...item} key={item.label} />
          ))}
        </nav>
      </div>
      <GetStartedButton />
    </div>
  </>
);
